module.exports = __webpack_public_path__ + "img/icon_eye.ab1cddb5.svg";